export const externalTypes = {
  Dmk: Symbol.for("Dmk"),
  SessionId: Symbol.for("SessionId"),
  ContextModule: Symbol.for("ContextModule"),
  DmkLoggerFactory: Symbol.for("DmkLoggerFactory"),
  SolanaRPCURL: Symbol.for("SolanaRPCURL"),
};
